import React, { createContext, useContext, useState, useCallback } from "react";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("success");

  const showAlertGlobal = useCallback((msg, type = "success", timeout = 2000) => {
    setMessage(msg);
    setVariant(type);
    setShow(true);
    if (timeout > 0) {
      setTimeout(() => setShow(false), timeout);
    }
  }, []);

  const hideAlert = () => setShow(false);

  return (
    <AlertContext.Provider value={{ show, message, variant, showAlertGlobal, hideAlert }}>
      {children}
    </AlertContext.Provider>
  );
};